import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';
import ReactDOM from 'react-dom';
import { messages } from '../../constants/messages';
import { messages_ar } from '../../constants/messages_ar';
import { messages_kk } from '../../constants/messages_kk';
import { messages_fr } from '../../constants/messages_fr';
import { messages_sv } from '../../constants/messages_sv';
import { messages_no } from '../../constants/messages_no';
import { messages_vi } from '../../constants/messages_vi';
import { messages_tr } from '../../constants/messages_tr';
import { messages_cy } from '../../constants/messages_cy';
import { messages_de } from '../../constants/messages_de';
import { messages_it } from '../../constants/messages_it';
import { messages_pt } from '../../constants/messages_pt';
import { messages_lt } from '../../constants/messages_lt';
import { showMessage } from '../../actions/FlashMessageActions';
import { Container, Row, Col, Card, CardImg, CardText, CardBody, CardTitle, CardSubtitle, Button, Form, FormGroup, Label, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import StarRatingComponent from 'react-star-rating-component';
import * as vars from '../../constants/variables';
import { searchText } from '../../actions/SearchActions';
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { getGameTypes, getCategories } from "../../actions/CategoryActions";
import { getSearchGames } from "../../actions/GamesActions";
import { console_log, appendUid,filterGames } from "../../utils/helper";
import FlashMessage from '../FlashMessage/FlashMessage';
import { FormattedMessage } from 'react-intl';
import { config } from '../../constants/domainConfig';
import { isCategoryAllowed } from '../../constants/restrictedCategories';
import { sendData } from '../../analytics/sendData';
import { isGamiclub } from '../../constants/isGamiclub';

const arabicDomain = (config.lang == 'ar') ? true : false;
const kazakhDomain = (config.lang=='kk')? true: false;
let msg;

switch (config.lang) {
    case 'ar': msg = messages_ar;
        break;
    case 'kk': msg = messages_kk;
        break;
    case 'fr': msg = messages_fr;
        break;
    case 'sv': msg = messages_sv;
        break;
    case 'no': msg = messages_no;
        break;
    case 'vi': msg = messages_vi;
        break;
    case 'tr': msg = messages_tr;
        break;
    case 'it': msg = messages_it;
        break;
    case 'cy': msg = messages_cy;
        break;
    case 'de': msg = messages_de;
        break;    
    case 'pt': msg = messages_pt;
        break;
    case 'lt': msg = messages_lt;
        break;    
    default: msg = messages;
        break;
}

class SearchPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            text: props.search.searchText,
            categoryId: '',
            categoryTypeId: '',
            sortBy: '',
            isValid: false,
            errorMessage: '',
            games:{searchedGames:[]}
        };
        this.onChange = this.onChange.bind(this);
        this.openGame = this.openGame.bind(this);
        this.searchGames = this.searchGames.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentWillMount() {
        var regEx = this.props.search.searchText;
        this.getGameTypes();
        this.getCategories();
        this.searchGames();
    }

    onChange(e) {
        this.setState({
            [e.target.name] : e.target.value
        });

        this.searchGames({
            [e.target.name] : e.target.value
        });
        
        this.setState({ text: e.target.value });
    }
    componentWillUnmount() {
        sendData('', '', '', '', { page: 'search page', search_term: this.props.search.searchText })
        this.props.searchText('');

    }

    getCategories() {
        axios.get(vars.BASE_URL + '/getCategories')
            .then((response) => {
                if (response.data.success) {
                    let dataFinal = response.data;
                    let categoriesArr = dataFinal.data;
                    dataFinal = { ...dataFinal, data: categoriesArr };
                    dataFinal.data = dataFinal.data.filter((category) => isCategoryAllowed(category.categoryName));
                    if(!(config.subDomain === 'cz' && isGamiclub)){
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'E-knihy'
                        })
                    }
                    if(config.subDomain === 'fr' && isGamiclub) {
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'Heróis Verdes'
                        })
                    }
                    if(config.subDomain === 'my' && window.location.hostname.includes('gamiclub')) {
                        dataFinal.data = dataFinal.data.filter(category => {
                            let excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos", "Political & Activism"]
                            return excludes.indexOf(category.categoryName) == -1
                        })
                    }
                    if(config.subDomain === 'es2' && window.location.hostname.includes('beemobi')) {
                        dataFinal.data = dataFinal.data.filter(category => {
                            let excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos"]
                            return excludes.indexOf(category.categoryName) == -1
                        })
                    }
                    else {
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'Videos Virales'
                        })
                    }
                    if(config.subDomain !== 'rs'){
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'Е-књиге'
                        })
                    }
                    if(config.subDomain !== 'tr' && config.subDomain !== 'qa' && config.subDomain !== 'kw'){
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'Facebook'
                        })
                    }
                    this.props.getCategories(dataFinal);
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.'});
            });
    }

    getGameTypes() {
        axios.get(vars.BASE_URL+'/getCategoryTypes')
            .then((response) => {
                if (response.data.success) {
                    this.props.getGameTypes(response.data);
                }
            })
            .catch((error) => {
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.'});
            });
    }

    searchGames(regEx) {
        let data = Object.assign({}, {
            text: regEx,
        }), urlParams = '';
        Object.keys(data).map(function(k) {
            if (data[k] != '' && data[k] != 0) {
                urlParams += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&'
            }
        });
        
        axios.get(vars.BASE_URL+'/getGames?'+urlParams+'&uid='+this.props.access.uid)
            .then((response) => {
                if (response.data.success) {
                    response.data.data = response.data.data.filter((game) => isCategoryAllowed(game.categoryName));
                    this.setState({games:{searchedGames:response.data}});
                }
            })
            .catch((error) => {
                this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.'});
            });
    }
    componentWillReceiveProps(nextProps){
            this.searchGames(nextProps.search.searchText);


    }

    openGame(game, e) {
        e.preventDefault();
        if (e.target.classList.contains('isFavorite'))  {
            let pEl;
                pEl= ReactDOM.findDOMNode(this.refs['star'+game.gameId]);
            let _check = !pEl.checked;
            let data = {
                uid: this.props.access.uid,
                gameId: game.gameId,
                isFavorite: _check
            };
            if(_check){
                this.props.showMessage({
                    message: msg.addToFavorites,
                    type: true
                });
            }else{
                this.props.showMessage({
                    message: msg.removeFromFavorites,
                    type: false
                });
            }
            sendData(game.gameTitle, game.categoryName, game.gameType, data.isFavorite ? 'favorite-added' : 'favorite-removed');
            axios.post(vars.BASE_URL+'/favorite', data)
                .then((response) => {
                    if(response.status){
                        pEl.checked = _check;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        } else if (e.target.tagName != 'INPUT') {
            this.props.searchText('');
            const searchContainer = document.querySelector("#search-container");
            const searchInput = document.querySelector("#search-input");
            const searchButton = document.querySelector("#search-button");
            const searchClear = document.querySelector(".search-clear");
            const searchCancel = document.querySelector(".search-cancel");
            searchContainer.classList.toggle("search-toggle");
            this.props.goToPage(appendUid('/detail/'+game.gameId, this.props.access.id));
        }
    }

    render() {
        var regEx = this.props.search.searchText;

        const starIcon = '<svg class="isFavorite" width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><linearGradient id="a" gradientTransform="rotate(-180)" gradientUnits="userSpaceOnUse" x1="0.3328" y1="14" x2="25.6672" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><linearGradient id="b" gradientTransform="rotate(-180)" gradientUnits="userSpaceOnUse" x1="0.2078" y1="14" x2="25.7922" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><path class="isFavorite" fill="url(#a)" stroke="url(#b)" stroke-width="100" d="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"/></svg>',
        thumbsUpIcon = '<svg width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="0.5" y1="14" x2="24.5" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><linearGradient id="b" gradientUnits="userSpaceOnUse" x1="0.375" y1="14" x2="24.625" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><path class="st0" fill="url(#a)" stroke="url(#b)" stroke-width="100" d="M320 1344q0-26-19-45t-45-19q-27 0-45.5 19t-18.5 45q0 27 18.5 45.5t45.5 18.5q26 0 45-18.5t19-45.5zm160-512v640q0 26-19 45t-45 19h-288q-26 0-45-19t-19-45v-640q0-26 19-45t45-19h288q26 0 45 19t19 45zm1184 0q0 86-55 149 15 44 15 76 3 76-43 137 17 56 0 117-15 57-54 94 9 112-49 181-64 76-197 78h-129q-66 0-144-15.5t-121.5-29-120.5-39.5q-123-43-158-44-26-1-45-19.5t-19-44.5v-641q0-25 18-43.5t43-20.5q24-2 76-59t101-121q68-87 101-120 18-18 31-48t17.5-48.5 13.5-60.5q7-39 12.5-61t19.5-52 34-50q19-19 45-19 46 0 82.5 10.5t60 26 40 40.5 24 45 12 50 5 45 .5 39q0 38-9.5 76t-19 60-27.5 56q-3 6-10 18t-11 22-8 24h277q78 0 135 57t57 135z"/></svg>';

        var gameCategoryTitleClass = "game-category-title";
        if (kazakhDomain) {
            gameCategoryTitleClass += ' kz-text';
        }
        return (
            <section className="search-page">
                <div>
                    <FlashMessage/>
                    <Container fluid>
                        <Row>
                            <Col xs="12">
                                <div className="game-category" style={isGamiclub ? {borderBottom: '1px solid green'} : null}>
                                    <h2 style = {isGamiclub ? {color: 'white', backgroundColor: 'green'} : null} className={gameCategoryTitleClass}><i className="fa fa-rocket" aria-hidden="true"></i>
                                        {isGamiclub ? <FormattedMessage id="directories"
                                            defaultMessage="Directories"
                                        />
                                        :
                                        <FormattedMessage id="gameDirectories"
                                            defaultMessage="Game Directories"
                                        />}
                                    </h2>
                                </div>
                            </Col>
                        </Row>
                        <Row className="game-list-row">
                            {(this.state.games.searchedGames.data && this.state.games.searchedGames.data.length > 0) ?
                                this.state.games.searchedGames.data.map((game) => {
                                    return (
                                        filterGames(game)?
                                        <Col xl="2" md="3" sm="4" xs="6" key={game.gameId}>
                                            <Card className={isGamiclub ? "game-card-gamiclub" : "game-card"} onClick={this.openGame.bind(this, game)}>
                                                <div className="game-card-inner">
                                                    <div className="game-thumb-wrap">
                                                        <CardImg className="game-thumb" top width="100%" src={game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage} alt={game.gameTitle} />
                                                    </div>
                                                    <div className="game-card-details">
                                                        <CardTitle className="game-title text-shadow">
                                                        <FormattedMessage id={`${game.gameTitle.toUpperCase()}`}
                                                         defaultMessage={game.gameTitle}/>
                                                        </CardTitle>
                                                        <div className="custom-rating isFavorite">
                                                            <input id={'fav'+game.gameId} ref={'star'+game.gameId} className="isFavorite" type="checkbox" checked={game.isFavorite}/>
                                                            <label htmlFor={'fav'+game.gameId} className="isFavorite">
                                                                <i style = {isGamiclub ? {color: 'green'} : null} className="fa fa-star-o custom-star isFavorite"></i>
                                                            </label>
                                                        </div>
                                                        {/*<StarRatingComponent className="abc isFavorite" name={'fav'+game.gameId} starCount={1} value={(game.isFavorite)? 1 : 0} editing={true} renderStarIcon={() => <i className="fa fa-star custom-star fa-gradient isFavorite"></i>}/>*/}
                                                        <div className="game-card-left">
                                                            <StarRatingComponent name="rate1" starCount={5} value={game.userRating} editing={false} renderStarIcon={() => <i style = {isGamiclub ? {color: 'green'} : null} className="fa fa-star custom-star"></i>} />
                                                        </div>
                                                        {config.subDomain != 'es' && 
                                                        <div className="game-card-right text-uppercase text-shadow text-right">{(game.gameType == 'HTML5')?<i className="fa fa-html5" aria-hidden="true"></i>:(game.gameType == 'ANDROID')?<i className="fa fa-android" aria-hidden="true"></i>:<i className="fa fa-video-camera" aria-hidden="true"></i>}</div>}
                                                        
                                                    </div>
                                                </div>
                                            </Card>
                                        </Col>:null
                                    )
                                })
                                : <Col xl="12" lg="12" md="12" sm="12" xs="12">
                                <p className="white-text-color no-game-text">
                                {window.location.hash.includes('home/video') ? 
                                <FormattedMessage id="noVideosFound" defaultMessage="No videos found." /> 
                                : <FormattedMessage id="noGamesFound" defaultMessage="No games found." />}
                                </p>
                                </Col>
                            }
                        </Row>
                    </Container>
                </div>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        games: state.GamesReducer,
        categories: state.CategoryReducer,
        search: state.SearchReducer,
        flashmessage: state.FlashMessageReducer,


    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getCategories,
        getGameTypes,
        getSearchGames,
        searchText,
        showMessage
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);



// WEBPACK FOOTER //
// ./src/components/SearchPage/SearchPage.js